<div class="wrapper">
  <div class="flex-container">
    <div class="message">
      <p>Your invitation has expired</p>
      <p>Ask your account administrator to send a new invitation to join this organisation</p>
      <p>The Land App Team</p>
    </div>
  </div>
</div>
